/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PopoverContentRightClick/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PopoverContentRightClick({
  children,
  viewPath = "/DesignSystem/Popover/PopoverContentRightClick",
  isRightClickOpen,
  contentRef,
  width = "100%",
  top,
  left,
  closePopover
  
}) {
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<fromFlow.When is={isRightClickOpen}>
<div
  data-testid="PopoverContentRightClick.Vertical"
  data-view-path={viewPath}
 ref={contentRef}
 style={{'--w-1-Z2dlKgO': typeof width === 'number' ? `${width}px` : width,'--t-2-Z2dlKgO': typeof top === 'number' ? `${top}px` : top,'--l-3-Z2dlKgO': typeof left === 'number' ? `${left}px` : left}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 closePopover={closePopover}
>
{children}
</Children>
</div>
</fromFlow.When>
)}
</FloatingPortal>
</React.Fragment>)
}